import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getRecalls(requestData) {
    return axios.post(ENV.carBaseUrl + "/recalls/list", requestData, this.requestConfig());
  }
}

export default Service;
